import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

/**
 * Wrapping the translateService for Enel purposes, including fallback rules, branding, etc
 */
@Injectable()
export class CookieService {
  cookies: object;

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.cookies = {};
    this.document.cookie.split(';').map(variable => {
      const variableParts = variable.split('=');
      this.cookies[variableParts[0].trim()] = variableParts[1];
    });
  }

  // Need to import the angular cookie service
  getCookie(cname: string | number, defaulter: unknown = null): string {
    return this.cookies[cname] || defaulter;
  }

  getDesSession(): string {
    return this.getCookie('des_session');
  }

  getLocale(): string {
    return this.getCookie('locale') || 'en_US';
  }

  getBannerAcknowledgement(): boolean {
    return this.getCookie('offhour_acknowledge') === 'true';
  }

  setBannerAcknowledgement(): void {
    this.setCookie('offhour_acknowledge', 'true', 0.045, '/');
  }

  /**
   * Gets the locale cookie formatted for i18n
   */
  getI18NLocale(): string {
    const raw = this.getCookie('locale') || '';
    return raw.replace('_', '-').toLowerCase();
  }

  /**
   * Gets the brand value formatted for i18n
   */
  getI18NBrand(): string {
    const raw = this.getCookie('default_brand') || '';
    return raw.toUpperCase();
  }

  private setCookie(
    name: string,
    value: string,
    expireDays: number,
    path: string = '',
  ): void {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }
}
